module.exports = __webpack_public_path__ + "bbf89b06.svg";